import React, { useRef, useState, useEffect } from "react";

import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table,
} from "reactstrap";

//Unform e componentes
import { Form } from "@unform/web";
import URadio from "@/frontend/componentes/unform/URadio";
import Paginacao from "@/frontend/componentes/Paginacao";

//Common
import {
  SITUACAO_APROVACAO,
  TIPO_APROVACAO_SOL,
  TIPO_LOG_APROVACAO,
} from "@/common/constantes";
import { fn_formatarData, fn_formatarDataHora } from "@/common/utils/date";
import { fn_formatarNumero, fn_isEmpty } from "@/common/utils/util";
import { fn_getResultPaginado, PAGINACAO } from "@/common/utils/paginacao";
import {
  fn_getTipoAprovacao,
  //fn_getTipoDocumento,
  fn_loadCamposLogAprovacao,
} from "@/common/siig";

//Util
import { ICONES_BOTAO } from "@/frontend/utils/icones";

//API
import { api_listar, ROTA_LISTAR } from "@/frontend/services/api/api_list";
import { api_loadOpcoes, ROTA_LOAD } from "@/frontend/services/api/api_load";

function TLog_det({ modalOpen, toggleModal, aprovacao }) {
  //### USE REF ###
  const formRef = useRef(null);

  //### USE STATE ###
  const [pageNumber, setPageNumber] = useState(1);
  const [result, setResult] = useState({
    pages: 0,
    count: 0,
    items: [],
    offset: 0,
    limit: 0,
  });

  const [opcoesTipoDocumento, setOpcoesTipoDocumento] = useState([]);
  const [camposLog, setCamposLog] = useState([]);
  const [logs, setLogs] = useState([]);
  const [logsAtual, setLogsAtual] = useState([]);
  const [logsAnteriores, setLogsAnteriores] = useState([]);

  const [rdTipoConsulta, setRdTipoConsulta] = useState("A");

  //### USE EFFECT ###
  //Inicialização da tela
  useEffect(() => {
    //Carrega as opções de tipo documento (PROVISORIO ENQUANTO NAO TEM RELACIONAMENTO COM A TABELA SOLICITACAO_PAG)
    async function loadOpcoesTipoDocumento() {
      const opcoes = await api_loadOpcoes(
        ROTA_LOAD.TIPO_DOCUMENTO,
        "situacao=A",
        { campoValue: "sigla" }, //provisorio até terminar toda a migração para tabela
      );
      setOpcoesTipoDocumento(opcoes);
    }

    //Lista os campos do log de aprovação
    function listarCamposLogAprovacao() {
      setCamposLog(fn_loadCamposLogAprovacao());
    }

    loadOpcoesTipoDocumento();
    listarCamposLogAprovacao();
  }, []);

  //Listagem da tela
  useEffect(() => {
    //Lista aos logs da aprovação
    async function listarLogsAprovacao() {
      let logs = [];

      if (aprovacao?.logs?.length > 0) {
        logs = aprovacao.logs;
      } else {
        logs = await api_listar(
          ROTA_LISTAR.SOLICITACAO_APROVACAO_LOG_PAG,
          `id_solicitacao_aprovacao=${aprovacao.id}`,
        );
      }

      const logsAtual = converterLogs(logs, camposLog);
      setLogsAtual(logsAtual);
      setLogs(logsAtual);
    }

    //Lista todos os logs de alteração de pagamento da solicitação, que foram aprovados
    async function listarLogsAlteracaoAprovados() {
      const aprovacoes = await api_listar(
        ROTA_LISTAR.SOLICITACAO_APROVACAO,
        `id_solicitacao=${aprovacao.id_solicitacao}&tipo=${TIPO_APROVACAO_SOL.ALTERACAO_PAGAMENTO}&situacao=${SITUACAO_APROVACAO.APROVADA}`,
      );

      const logs = aprovacoes.flatMap((ap) =>
        ap.logs.map((log) => ({
          ...log,
          id_aprovacao: ap.id,
          data_aprovacao: ap.data_aprovacao,
        })),
      );

      const logsFilter = logs.filter(
        (log) => Number(log.id_aprovacao) < Number(aprovacao.id),
      );

      const logsAnteriores = converterLogs(logsFilter, camposLog);
      setLogsAnteriores(logsAnteriores);
    }

    listarLogsAprovacao();

    if (aprovacao.tipo == TIPO_APROVACAO_SOL.ALTERACAO_PAGAMENTO) {
      listarLogsAlteracaoAprovados();
    }
  }, [camposLog]);

  //Paginação do resultado
  useEffect(() => {
    setResult(
      fn_getResultPaginado(pageNumber, logs, PAGINACAO.ITENS_POR_PAGINA_MIN),
    );
  }, [logs, pageNumber]);

  //### FUNÇÕES ###
  //Retorna o objeto tipo documento conforme a sigla (PROVISORIO COM SIGLA)
  function getTipoDocumentoBySigla(sigla) {
    return opcoesTipoDocumento.find((tp) => tp.sigla == sigla);
  }

  //Retorna o objeto tipo documento conforme o id
  function getTipoDocumentoById(id) {
    return opcoesTipoDocumento.find((tp) => tp.id == id);
  }

  //Retorna o valor do log
  function getValor(nomeCampo, log) {
    const valor =
      nomeCampo == "tipo_documento"
        ? getTipoDocumentoBySigla(log[nomeCampo])?.label
        : nomeCampo == "id_tipo_documento"
          ? getTipoDocumentoById(log[nomeCampo])?.label
          : log[nomeCampo];

    return valor;
  }

  //Converte os logs para aprsentar na tela
  function converterLogs(logs, camposLog) {
    const logPag = {};

    logs.forEach((item) => {
      const key = item.num_pag + "-" + item.id_aprovacao;

      // Se não existe ainda, cria a primeira estrutura
      if (!logPag[key]) {
        logPag[key] = {
          num_pag: item.num_pag,
          data_aprovacao: item.data_aprovacao,
          orig: {},
          novo: {},
        };
      }

      // Determina se o item pertence ao orig ou novo
      const tipo = item.tipo === TIPO_LOG_APROVACAO.ORIGINAL ? "orig" : "novo";

      camposLog.forEach((campoLog) => {
        logPag[key][tipo][campoLog.nome_campo] =
          campoLog.tipo_valor == "D" //Data
            ? fn_formatarData(item[campoLog.nome_campo])
            : campoLog.tipo_valor == "N" //Número
              ? fn_formatarNumero(item[campoLog.nome_campo], 2)
              : item[campoLog.nome_campo];
      });
    });

    Object.values(logPag).forEach((log) => {
      log.alterado = verificarAlteracaoPag(log.orig, log.novo);
    });

    return Object.values(logPag);
  }

  //Verifica se houve alteração no pagamento
  function verificarAlteracaoPag(orig, novo) {
    const keys = new Set([...Object.keys(orig), ...Object.keys(novo)]);

    for (const key of keys) {
      if (orig[key] != novo[key]) {
        return true;
      }
    }

    return false;
  }

  //### EVENTOS ###
  function handleChangeTipoConsulta(event) {
    const valor = event.target.value;

    if (valor == "A") {
      setLogs(logsAtual);
      setPageNumber(1);
    } else if (valor == "T") {
      setLogs(logsAnteriores);
      setPageNumber(1);
    }

    setRdTipoConsulta(valor);
  }

  return (
    <Modal isOpen={modalOpen} backdrop="static" size="xxl">
      <ModalHeader toggle={toggleModal} className="titulo-tela-modal">
        {`Consulta ${fn_getTipoAprovacao(aprovacao.tipo)?.label?.toLowerCase() || "log"}`}
      </ModalHeader>

      <ModalBody>
        <div className="m-1">
          {aprovacao.tipo == TIPO_APROVACAO_SOL.ALTERACAO_PAGAMENTO && (
            <Form ref={formRef}>
              <div className="mb-2">
                <URadio
                  name="tipo_consulta"
                  data={[
                    {
                      value: "A",
                      label: `Pagamento ${aprovacao.situacao == SITUACAO_APROVACAO.PENDENTE ? "para aprovar" : aprovacao.situacao == SITUACAO_APROVACAO.REJEITADA ? "rejeitado" : "aprovado"}`,
                    },
                    {
                      value: "T",
                      label: "Aprovações anteriores de todos os pagamentos",
                    },
                  ]}
                  defaultChecked={"A"}
                  onChange={handleChangeTipoConsulta}
                />
              </div>
            </Form>
          )}

          <div className="scroll-modal-fixed">
            <Table responsive>
              <thead>
                <tr>
                  {(rdTipoConsulta == "T" ||
                    aprovacao.situacao == SITUACAO_APROVACAO.APROVADA) && (
                    <td
                      width="7%"
                      align="center"
                      className="table-header texto-menor"
                    >
                      Data aprovação
                    </td>
                  )}
                  <td
                    width="7%"
                    align="center"
                    className="table-header texto-menor"
                  >
                    Num pag.
                  </td>

                  <td width="12%" className="table-header texto-menor">
                    Tipo valor
                  </td>

                  {camposLog.map((campoLog, index) => (
                    <td
                      key={index}
                      align="center"
                      className="table-header texto-menor"
                    >
                      {campoLog.label}
                    </td>
                  ))}
                </tr>
              </thead>

              <tbody>
                {result.items.map((log, index) => (
                  <React.Fragment key={index}>
                    {rdTipoConsulta == "T" && index > 0 && log.num_pag == 1 && (
                      <tr>
                        <td colSpan={3 + camposLog.length}>
                          <div className=" mb-3"></div>
                        </td>
                      </tr>
                    )}

                    <tr
                      className={`texto-menor ${rdTipoConsulta == "T" && aprovacao?.solicitacao_pag?.num_pag == log.num_pag ? "realce-bg-cinza" : ""}`}
                    >
                      {(rdTipoConsulta == "T" ||
                        aprovacao.situacao == SITUACAO_APROVACAO.APROVADA) && (
                        <td align="center">
                          {fn_formatarDataHora(
                            log.data_aprovacao || aprovacao.data_aprovacao,
                          )}
                        </td>
                      )}

                      <td align="center" className="fw-bold">
                        {log.num_pag}
                      </td>

                      <td>
                        {fn_isEmpty(log.orig) ? (
                          <div>
                            {aprovacao.tipo ==
                            TIPO_APROVACAO_SOL.REAJUSTE_CONTRATO
                              ? "Aprovação reajuste"
                              : "Aprovação inclusão"}
                          </div>
                        ) : (
                          <div>
                            Última aprovação:
                            {(log.alterado && (
                              <div className="mt-2">
                                {aprovacao.situacao ==
                                  SITUACAO_APROVACAO.APROVADA ||
                                rdTipoConsulta == "T" ? (
                                  <span className="fw-bold">
                                    {aprovacao.tipo ==
                                    TIPO_APROVACAO_SOL.REAJUSTE_CONTRATO
                                      ? "Reajustado para:"
                                      : "Alterado para:"}
                                  </span>
                                ) : (
                                  <span className="fw-bold text-danger">
                                    {aprovacao.tipo ==
                                    TIPO_APROVACAO_SOL.REAJUSTE_CONTRATO
                                      ? "Reajustar para:"
                                      : "Alterar para:"}
                                  </span>
                                )}
                              </div>
                            )) || <div className="fw-bold">Sem alteração</div>}
                          </div>
                        )}
                      </td>

                      {camposLog.map((campoLog, index) => (
                        <td key={index} align="center" className="texto-menor">
                          {(fn_isEmpty(log.orig) && (
                            <div>{getValor(campoLog.nome_campo, log.novo)}</div>
                          )) || (
                            <div>
                              {/* {
                                //Valor original
                                campoLog.nome_campo == "tipo_documento"
                                  ? getTipoDocumentoBySigla(
                                      log.orig[campoLog.nome_campo],
                                    )?.label
                                  : log.orig[campoLog.nome_campo]
                              } */}
                              {
                                //Valor original
                                getValor(campoLog.nome_campo, log.orig)
                              }

                              {
                                //Valor novo só se for diferente do original
                                log.orig[campoLog.nome_campo] !=
                                  log.novo[campoLog.nome_campo] && (
                                  <div
                                    className={`mt-2 fw-bold ${
                                      aprovacao.situacao ==
                                        SITUACAO_APROVACAO.PENDENTE &&
                                      rdTipoConsulta != "T"
                                        ? "text-danger"
                                        : ""
                                    }`}
                                  >
                                    {/* {campoLog.nome_campo == "tipo_documento"
                                      ? getTipoDocumentoBySigla(
                                          log.novo[campoLog.nome_campo],
                                        )?.label
                                      : log.novo[campoLog.nome_campo]} */}
                                    {getValor(campoLog.nome_campo, log.novo)}
                                  </div>
                                )
                              }
                            </div>
                          )}
                        </td>
                      ))}
                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
            </Table>
          </div>
          <Paginacao
            result={result}
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
          />
        </div>
      </ModalBody>

      <ModalFooter>
        <Button name="btnFechar" color="secondary" onClick={toggleModal}>
          {ICONES_BOTAO.FECHAR} Fechar
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default TLog_det;
